import { request } from "../lib/api-client.ts";
import { API_BASE } from "../lib/api-routes.ts";

/**
 * Espejo a mano de `AttachmentView`
 * (`attachments/attachment/application/queries/list-attachments/list-attachments.query.ts`).
 * No sale de un esquema generado: `AttachmentUploadController` es un
 * controller Nest a mano (ver el comentario de `uploadAttachment`), así que
 * el OpenAPI generado no trae el cuerpo de éxito de esta ruta.
 */
export interface UploadedAttachment {
  readonly attachmentId: string;
  readonly fileName: string;
  readonly mimeType: string;
  readonly sizeBytes: number;
  readonly uploadedAt: string;
}

/** Lo que el backend sabe leer hoy. */
export const ACCEPTED_FILES = ".xlsx,.xls,.csv";

export const MAX_UPLOAD_BYTES = 32 * 1024 * 1024;

/**
 * `POST /api/ccmas/v1/conversations/:conversationId/attachments` ya existe
 * (`AttachmentUploadController`, confirmado en `src/lib/api-types.ts` y en
 * `.referencia/contexto/f3d-back.md`): controller Nest a mano, multipart con
 * un solo campo `file`, igual que este cliente ya mandaba. Responde SIN
 * envoltorio `data` (a diferencia de `transcriptions`), tal como `request`
 * ya lo asume abajo.
 *
 * Por `request` como todo lo demas: el cuerpo es multipart y `request` ya sabe
 * no ponerle Content-Type, y asi el token, la base y el sobre de error son los
 * mismos que en el resto del cliente.
 */
export const uploadAttachment = (
  conversationId: string,
  file: File,
): Promise<UploadedAttachment> => {
  const body = new FormData();
  body.append("file", file);

  return request<UploadedAttachment>(
    `${API_BASE}/conversations/${conversationId}/attachments`,
    { method: "POST", body },
  );
};

/**
 * `POST /api/ccmas/v1/conversations` ya existe (`ConversationsController`,
 * confirmado en `src/lib/api-types.ts` y en
 * `.referencia/contexto/f3d-back.md`): crea una conversación vacía, sin
 * cuerpo, y devuelve `{ conversationId }` tal como ya se esperaba abajo --
 * decisión explícita del back (envolver el `string` bare que devuelve el
 * comando), no una ruta a mano por ausencia de catálogo.
 */
export const startConversation = async (): Promise<string> => {
  const { conversationId } = await request<{ conversationId: string }>(
    `${API_BASE}/conversations`,
    { method: "POST" },
  );
  return conversationId;
};
